import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import CapitalControlExpertise from "./sections/CapitalControlExpertise";
import TheDeliveryProcess from "./sections/TheDeliveryProcess";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <CapitalControlExpertise />
      <TheDeliveryProcess />
      <Footer />
    </div>;
}